/* tslint:disable */
/* eslint-disable */
import { mapValues } from '../runtime';

export interface ShopProductOptionChoice {
  id?: number;
  optionId?: number;
  name?: string;
  priceModifier?: number;
  sortOrder?: number;
  isDefault?: boolean;
}

export function ShopProductOptionChoiceFromJSON(json: any): ShopProductOptionChoice {
  return ShopProductOptionChoiceFromJSONTyped(json, false);
}

export function ShopProductOptionChoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopProductOptionChoice {
  if (json == null) { return json; }
  return {
    'id': json['id'] == null ? undefined : json['id'],
    'optionId': json['optionId'] == null ? undefined : json['optionId'],
    'name': json['name'] == null ? undefined : json['name'],
    'priceModifier': json['priceModifier'] == null ? undefined : json['priceModifier'],
    'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
  };
}

export function ShopProductOptionChoiceToJSON(value?: ShopProductOptionChoice | null): any {
  if (value == null) { return value; }
  return {
    'id': value['id'],
    'optionId': value['optionId'],
    'name': value['name'],
    'priceModifier': value['priceModifier'],
    'sortOrder': value['sortOrder'],
    'isDefault': value['isDefault'],
  };
}
